// extracted by mini-css-extract-plugin
export var active = "navMobile-module--active--e772f";
export var langSelect = "navMobile-module--langSelect--f597b";
export var link = "navMobile-module--link--faca2";
export var mobileNav = "navMobile-module--mobileNav--ac0e8";
export var nav = "navMobile-module--nav--1a7cb";